import script from "./Hexagon.vue?vue&type=script&setup=true&lang=js"
export * from "./Hexagon.vue?vue&type=script&setup=true&lang=js"

import "./Hexagon.vue?vue&type=style&index=0&id=79ddff28&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ddff28"]])

export default __exports__